module.exports = __webpack_public_path__ + "img/img1.5c88d33.png";